import { h, Fragment } from 'preact';
import useFormStore from '../../store/useFormStore';
import { formatDateForDisplay } from '../../util/helper';

export default function ShortLeadInfoBlock() {
  const shortLeadFormPreferredDate = useFormStore((state) => state.shortLeadFormPreferredDate);
  const shortLeadFormNote = useFormStore((state) => state.shortLeadFormNote);
  const selectedServices = useFormStore((state) => state.selectedServices) || [];
  const getServiceById = useFormStore((state) => state.getServiceById);

  // Get service names from selected service IDs
  const getServiceNames = () => {
    if (selectedServices.length === 0) {
      return [];
    }
    return selectedServices
      .map(serviceId => getServiceById(serviceId)?.name)
      .filter(Boolean);
  };

  const serviceNames = getServiceNames();

  return (
    <div className="short-lead-info-block flex flex-col gap-2.5 bg-white p-6 shadow-sm rounded-lg border border-gray-200 max-h-[350px] overflow-y-auto">
      <div className="text-2xl font-semibold">Requested Services</div>
      {serviceNames.length > 0 ? (
        <div>
          <ul className="mt-2 list-disc list-inside space-y-1 ml-0 mb-0">
            {serviceNames.map((name, index) => (
              <li key={index} className="text-gray-700">{name}</li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="font-bold mt-2">Select services to get started..</p>
      )}
      {shortLeadFormPreferredDate && (
        <p className="mb-0"><b>Preferred Date:</b> {formatDateForDisplay(shortLeadFormPreferredDate)}</p>
      )}
      {shortLeadFormNote && (
        <div>
          <div className="text-lg font-semibold">Additional Information:</div>
          <p className="mb-0">{shortLeadFormNote}</p>
        </div>
      )}
    </div>
  )
}
